<div class="cookie-banner" *ngIf="isVisible">
  <div class="content">
    <p>
      We use cookies to collect anonymous performance data to improve your experience.
    </p>
    <div class="actions">
      <button mat-button (click)="decline()">Decline</button>
      <button mat-raised-button color="primary" (click)="accept()">Accept</button>
    </div>
  </div>
</div>

